import React from 'react';
import { userStore } from '../../store';

import RadioButton from '../radioButton/RadioButton';

import { useTranslation } from 'react-i18next';
import type { SearchResource } from '../../api/types/index';
import { SEARCH_RESOURCES } from '../../js/_constants';


import './SearchResourceSelector.scss';

type SearchResourceSelectorProps = {
    searchResource: SearchResource;
    onOptionClick: (resource: SearchResource) => void;
};

const SearchResourceSelector = ({
    searchResource,
    onOptionClick
}: SearchResourceSelectorProps) => {
    const { t } = useTranslation();
    const { dealerships } = userStore();
    return (
        <div className="b-search-resource-selector">
            <div className="radio-container">
                <RadioButton
                    checked={searchResource === SEARCH_RESOURCES.MEDIA}
                    onClick={() => onOptionClick(SEARCH_RESOURCES.MEDIA)}
                    label="Media"
                    name="radio-button-media"
                />
                <RadioButton
                    checked={searchResource === SEARCH_RESOURCES.PLAYLIST}
                    onClick={() => onOptionClick(SEARCH_RESOURCES.PLAYLIST)}
                    label={t('playlists')}
                    name="radio-button-playlist"
                />
                <RadioButton
                    checked={searchResource === SEARCH_RESOURCES.DEVICE}
                    onClick={() => onOptionClick(SEARCH_RESOURCES.DEVICE)}
                    label={t('devices')}
                    name="radio-button-device"
                />
                {dealerships?.list.length > 1 && <RadioButton
                    checked={searchResource === SEARCH_RESOURCES.DEALERSHIP}
                    onClick={() => onOptionClick(SEARCH_RESOURCES.DEALERSHIP)}
                    label={t('dealerships')}
                    name="radio-button-dealership"
                />}
            </div>
        </div>
    );
};

export default SearchResourceSelector;